import React, { useEffect, useState } from 'react';
import './Footer.css';
import instaIcon from './images/instagram-svgrepo-com.svg';
import gitIcon from './images/github-142-svgrepo-com.svg';
import linkedIcon from './images/linkedin-svgrepo-com.svg';

function Footer() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1800); // Appears after Hero
    return () => clearTimeout(timer);
  }, []);

  return (
    <footer className={`footer ${visible ? 'fade-in-smooth' : 'hidden'}`}>
      <div className="footer-icons">
        <a href="https://instagram.com/amaansii" target="_blank" rel="noopener noreferrer">
          <img src={instaIcon} alt="Instagram" />
        </a>
        <a href="https://github.com/AmaanSiddiqi" target="_blank" rel="noopener noreferrer">
          <img src={gitIcon} alt="GitHub" />
        </a>
        <a href="https://www.linkedin.com/in/amaan-siddiqi-38b7021b0/" target="_blank" rel="noopener noreferrer">
          <img src={linkedIcon} alt="LinkedIn" />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
